import { OktaAuth } from '@okta/okta-auth-js';

// Okta Configuration - same client for all environments
const OKTA_CLIENT_ID = (import.meta.env.VITE_OKTA_CLIENT_ID as string | undefined)
  ?? '0oa2qymuxckGuCbov0h8';

const configuredDomain = (import.meta.env.VITE_OKTA_DOMAIN as string | undefined)
  ?? 'https://testmyapps.freeman.com';

const OKTA_DOMAIN = configuredDomain
  .replace(/^https?:\/\//, '')
  .replace(/\/$/, '');

// const OKTA_AUTH_SERVER = (import.meta.env.VITE_OKTA_AUTH_SERVER as string | undefined)
//   ?? 'default';

// ISSUER: For Okta Org AS (testmyapps.freeman.com), use the tenant issuer, not authorization server
// Org AS OIDC endpoint: https://testmyapps.freeman.com/.well-known/openid-configuration
const OKTA_ISSUER = `https://${OKTA_DOMAIN}`;

// Environment-specific URLs
// OAuth redirect URI: where Okta sends the authorization code (always /login/callback)
const REDIRECT_URI = `${window.location.origin}/login/callback`;

// Post-logout redirect: where user goes after logout
// Local: http://localhost:3001/logout
// Dev: https://brg.dev.freeman.com/logout
// QA: https://brg.qa.freeman.com/logout
const POST_LOGOUT_REDIRECT_URI = `${window.location.origin}/logout`;

// After successful OAuth callback, user is redirected to /admin (see LoginCallbackPage.tsx)

export const oktaConfig = {
  clientId: OKTA_CLIENT_ID,
  issuer: OKTA_ISSUER,
  redirectUri: REDIRECT_URI,
  postLogoutRedirectUri: POST_LOGOUT_REDIRECT_URI,
  scopes: ['openid', 'profile', 'email', 'groups'],
  pkce: true,
  maxClockSkew: 300,
  tokenManager: {
    autoRenew: true,
  },
  // After successful token exchange, SDK calls this to restore the original page.
  // We override to always go to /admin (the dashboard) since LoginPage is just for sign-in.
  restoreOriginalUri: async (_oktaAuth: any, _originalUri?: string) => {
    // Replace current location with /admin - this is where authenticated users belong.
    // The AuthProvider's checkAuth will verify roles on the admin page.
    window.location.replace('/admin');
  },
};

export const oktaAuth = new OktaAuth(oktaConfig);

// Suppress initialization errors when not on callback page
// The SDK checks URL for OAuth params on init, which causes harmless errors on login page
if (typeof window !== 'undefined' && window.location.pathname !== '/login/callback') {
  // Clear any OAuth parsing errors from non-callback pages
  const originalError = console.error;
  const suppressOAuthErrors = (...args: any[]) => {
    const message = args[0];
    // Suppress "Unable to parse a token from the url" errors on non-callback pages
    if (typeof message === 'string' && message.includes('[Okta]') && 
        (message.includes('Unable to parse') || message.includes('Callback error'))) {
      return; // Suppress this expected error
    }
    originalError(...args);
  };
  
  // Temporarily replace console.error during initialization
  console.error = suppressOAuthErrors;
  
  // Restore after a tick
  setTimeout(() => {
    console.error = originalError;
  }, 100);
}
